import React from 'react';
import FormGroup from '@material-ui/core/FormGroup';
import { PaymentPlanList } from './PaymentPlanList/PaymentPlanList';
import { ConfirmationButton } from "../ConfirmationButton/ConfirmationButton";
import cn from './PaymentPlanForm.module.scss';

export class PaymentPlanForm extends React.PureComponent {
  state = {
    paymentPlans: [],
    minPrice: '',
    maxPrice: '',
    errors: [],
  };

  componentDidMount() {
    const { initialPlans, minPrice, maxPrice } = this.props;
    this.setState({
      paymentPlans: initialPlans,
      minPrice,
      maxPrice,
    }, this.validate);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { minPrice, maxPrice, initialPlans } = this.props;
    if (prevProps.minPrice !== minPrice) {
      this.setState({
        minPrice,
      }, this.validate);
    }

    if (prevProps.maxPrice !== maxPrice) {
      this.setState({
        maxPrice,
      }, this.validate);
    }

    if (prevProps.initialPlans !== initialPlans) {
      this.setState({
        paymentPlans: initialPlans,
      })
    }
  }

  validate = () => {
    const { paymentPlans } = this.state;
    const { minPrice, maxPrice } = this.state;
    const paymentPlansPrices = paymentPlans.reduce((current, next) => [...current, next.price], []);
    const duplicatedPrices = paymentPlansPrices.filter((price, index) => paymentPlansPrices.indexOf(price) !== index);
    const errors = paymentPlans.map(plan => {
      let error = '';
      if (minPrice && maxPrice && (plan.price < minPrice || plan.price > maxPrice)) {
        error = `Price should be between $${minPrice} and $${maxPrice}`;
      } else if (minPrice && plan.price < minPrice) {
        error = `Min price is $${minPrice}`;
      } else if (maxPrice && plan.price > maxPrice) {
        error = `Max price is $${maxPrice}`;
      } else if (plan.price === 0) {
        error = 'Price should not be 0';
      } else if (duplicatedPrices.includes(plan.price)) {
        error = 'Price should be unique';
      }
      return error;
    });

    this.setState({
      errors,
    });
  };

  handlePaymentPlanChange = (paymentPlan, updatedPaymentPlan) => {
    this.setState(state => ({
      paymentPlans: state.paymentPlans.map(plan => plan === paymentPlan ? updatedPaymentPlan : plan),
    }), this.validate);
  };

  handlePaymentPlanAdd = () => {
    this.setState(state => ({
      paymentPlans: [...state.paymentPlans, {
        price: 0,
        options: [
          {
            months: 1,
            fee: 0,
            enabled: true,
          },
        ],
      }]
    }));
  };

  handlePaymentPlanDelete = (paymentPlan) => {
    this.setState(state => ({
      paymentPlans: state.paymentPlans.filter(plan => plan !== paymentPlan),
    }), this.validate);
  };

  handlePaymentPlansSubmit = () => {
    const { paymentPlans } = this.state;
    this.props.onSubmit(paymentPlans);
  };

  handlePaymentPlanDefaultChange = (paymentPlan) => {
    const { paymentPlans } = this.state;
    this.setState({
      paymentPlans: paymentPlans.map(plan => {
        return paymentPlan === plan ? {...plan, default: true} : {...plan, default: false};
      })
    })
  };

  render() {
    const { paymentPlans, errors } = this.state;
    const { onSubmit } = this.props;
    const isSaveDisabled = errors.some(error => error);
    return (
      <div>
        <div className={cn.label}>Configure payments plans</div>
        <PaymentPlanList
          paymentPlans={paymentPlans}
          onPaymentPlanChange={this.handlePaymentPlanChange}
          onPaymentPlanAdd={this.handlePaymentPlanAdd}
          onPaymentPlanDelete={this.handlePaymentPlanDelete}
          onPaymentPlanDefaultChange={this.handlePaymentPlanDefaultChange}
          errors={errors}
          className={cn.paymentPlanList}
        />
        {onSubmit && (
          <FormGroup row classes={{ root: cn.saveButton }}>
            <ConfirmationButton
              disabled={isSaveDisabled}
              onClick={this.handlePaymentPlansSubmit}
            />
          </FormGroup>
        )}
      </div>
    );
  }
}
